export enum mediaType{
    IMAGE='IMAGE',
    VIDEO='VIDEO',
    DOCUMENT='DOCUMENT'
    }


    export interface IMedia{
        _id:string,
        name:string,
        type:mediaType,
        url:string,
        size:number,
        description:string,
        active:boolean,
        createdBy:string,
        fileId:string,
        createdAt:Date,
        updatedAt:Date
    
    }